<template>
  <div id="wrap-physical-attributes">
    <div class="action-armor">
      <p>Armor</p>
      <input type="number" min="0" v-model="armor" />
    </div>
    <div class="action-hit-points">
      <p>Hit Points</p>
      <input type="number" min="0" v-model="hp" />
      <span class="subnote">Max (6+Constitution)</span>
    </div>
    <div class="action-damage">
      <p>Damage</p>
      <!-- <img src="#" alt=""> -->
      <p>{{ damage }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "CharacterPhysicalAttributes",
  computed: {
    armor: {
      get() {
        return this.$store.state.character.armor;
      },
      set(value) {
        this.$store.commit("updateCharacterProperty", {
          type: "armor",
          property: Number(value)
        });
      }
    },
    hp: {
      get() {
        return this.$store.state.character.hp.current;
      },
      set(value) {
        this.$store.commit("updateCharacterHP", Number(value));
      }
    },
    damage() {
      return this.$store.state.character.damage;
    }
  }
};
</script>
<style lang="css">
#wrap-physical-attributes {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
}

#wrap-physical-attributes * {
  text-align: center;
}

#wrap-physical-attributes > * > input {
  width: 2em;
  height: 2em;
  border-radius: 100%;
}

.action-hit-points {
  margin-right: -1em;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>